import { Injectable } from '@angular/core';
import { UtyscServicePkg } from './utyscPkg.service';
import { Utysc } from '../entity/Utysc-angular';

@Injectable({
  providedIn: 'root',
})
export class UtyscService extends UtyscServicePkg {
  constructor() {
    super();
  }
override async newRecord(newItem: Utysc): Promise<Utysc> {
    let item = await super.newRecord(newItem);

    item.SC001 = this.linkKeyObj.SC001;
    item.SC002 = this.linkKeyObj.SC002;
    return item;
  }
}
